<template>
  <base-section
    id="how-to"
  >
  <v-container>
    <base-section-heading
      title="How To Reach San Servolo Congress Center"
    >
    San Servolo is an island of Venice, located in front of San Marco’s square quartier.<br><br>
    <v-btn
      href="timesheet_line20.pdf"
      target="_blank"
      rounded
      color="green"
      dark
      download
      style="padding: 15px"
    >
      <v-icon
        left
        dark
      >
        mdi-cloud-download
      </v-icon>
      Download PDF timesheet line 20
    </v-btn>
    <br>
    <br>
    <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2800.5402060824817!2d12.357352299999997!3d45.418610699999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477eafca2bab1b79%3A0x5cbc97ceeeb68c44!2sSan%20Servolo!5e0!3m2!1sen!2sit!4v1679991879534!5m2!1sen!2sit"
    width="100%"
    height="450"
    style="border:0;"
    allowfullscreen=""
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
    </base-section-heading>
    <base-section-heading
        title="From the Airport"
    >
    <div style="text-align: left !important">
	You may consider about 2 hours to reach San Servolo. To reach on Monday, in time for the TSS tutorials (starting at 3PM), we suggest you select a flight to land by 12PM at the latest.<br>
    There are two main possibilities:<br>
    &emsp;<strong>•	by BOATS – this is the preferable path to avoid many changes</strong><br>
    &emsp;&emsp;    1.	from the airport arrivals walk to the “darsena” of the airport: it is a pier reachable at walking distance from the arrival terminal. From there, ALILAGUNA boats departs for Venice Downtown (line “BLU” - <a href="https://www.alilaguna.it/linee/linea-blu">line "BLU"</a> - <a href="https://www.alilaguna.it/linee/linea-blu/orario#&gid=1&pid=1">timesheet</a>). Possibly reach the San Zaccaria “B” stop. The San Zaccaria “B” pier is in downtown, close to San Marco Square and at walking distance to hotel in this zone.<br>
    &emsp;&emsp;    2.	From San Zaccaria “B” take line 20 to San Servolo (<a href="https://actv.avmspa.it/sites/default/files/avm/navigazione/Actv_nav_linea_20.pdf">timesheet</a>)<br>
    &emsp;<strong>•	By BUS + BOATS – less preferable but convenient in terms of price</strong><br>
    &emsp;&emsp;    1.	From the airport take BUS line 5 (<a href="https://actv.avmspa.it/sites/default/files/attachments/pdf/UM/U-5.pdf">timesheet</a>) or 35 (<a href="https://www.atvo.it/allegati/aeroporti/linea_035_-_09.06.22_28.10.23.pdf">timesheet</a>), direction Piazzale Roma in Venice. When you reach there, you are already in downtown.<br>
    &emsp;&emsp;    2.	Cross the Grand Canal to reach Piazzale Roma and take a ferry boat from the pier Piazzale ROMA “G” to San Zaccaria “B” stop (line 2 – <a href="https://orari.actv.it/stop.html?stopid=5031&service=NAV&date=2023-03-28">timesheet</a>)<br>
    &emsp;&emsp;    3.	From San Zaccaria “B” take line 20 to San Servolo (<a href="https://actv.avmspa.it/sites/default/files/avm/navigazione/Actv_nav_linea_20.pdf">timesheet</a>).<br>
    </div>
    </base-section-heading>
    <base-section-heading
        title="From the Venezia Santa Lucia train station"
    >
    <div style="text-align: left !important">
	If you reach by train, make sure you arrive at the Santa Lucia train station. It is already in downtown! From there, you may consider about 1 hours to reach San Servolo. To reach on Monday, in time for the TSS tutorials (starting at 3PM), we suggest you select a train to arrive by 1PM at the latest.<br>
    Monday, in time for the TSS tutorials (starting at 3PM), we suggest you select a train to arrive by 1PM at the latest.<br>
    &emsp;1.	Cross the Grand Canal to reach Piazzale Roma and take a ferry boat from the pier Piazzale ROMA “G” to San Zaccaria “B” stop (line 2 – <a href="https://orari.actv.it/stop.html?stopid=5031&service=NAV&date=2023-03-28">timesheet</a>)<br>
    &emsp;2.	From San Zaccaria “B” take line 20 to San Servolo (<a href="https://orari.actv.it/line.html?service=NAV&linename=20&subsector=&direction=0&time=07%3A18&date=2023-03-28">timesheet</a>)<br>
    </div>
    </base-section-heading>
    <base-section-heading
        title="From Venice downtown"
    >
    <div style="text-align: left !important">
	• From San Zaccaria “B” take line 20 to San Servolo (<a href="https://orari.actv.it/line.html?service=NAV&linename=20&subsector=&direction=0&time=07%3A18&date=2023-03-28">timesheet</a>)<br>
	• On Monday, if you want to reach in time for the TSS Tutorials starting at 3PM, you need to take the boat by 2:30PM.<br>
	• On Tuesday, if you want to reach the opening plenary session starting at 9AM, you need to take the boat by 8:40AM at latetst (we suggest you to consider also departing at 8:10AM or 8:20AM to reach a little before)<br>
	• From Wednesday to Friday, if you want to reach the first session starting at 8:30AM, you need to take the boat by 8:20AM at latetst (we suggest you to consider also departing at 8:10AM to reach a little before)<br>
    </div>
    </base-section-heading>
      <br>
      <br>
        <v-footer
          id="regional-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in venuefooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < venuefooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'HotelRooms',
    data: () => ({
      isMobile: false,
      venuefooter: [
        {
          name: 'City of Venice',
          url: 'venice',
        },
        {
          name: 'Congress Center',
          url: 'congress-center',
        },
        {
          name: 'How To Reach',
          url: 'how-to',
        },
        {
          name: 'Hotel Rooms',
          url: 'hotel-rooms',
        },
        {
          name: 'Visa',
          url: 'visa',
        },
      ],
    }),
    mounted () {
      this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
<style>
.v-btn__content {
  width: 100%;
  white-space: break-spaces;
}
</style>
